import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonMode, ButtonSize, ButtonTheme } from '@fcom/ui-components';

@Component({
  selector: 'fin-modify-button',
  templateUrl: 'modify-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModifyButtonComponent {
  readonly ButtonTheme = ButtonTheme;
  readonly ButtonSize = ButtonSize;
  readonly ButtonMode = ButtonMode;

  @Input()
  label: string;

  @Output()
  clicked: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}
}
